export default "__VITE_ASSET__CDwevoXQ__"